<template>
  <div
    class="exam-search"
    :class="{ 'exam-search-results': results }"
  >
    <h1
      v-if="title"
      class="exam-search__title"
    >
      Guia de Exames
    </h1>
    <div class="exam-search__wrapper">
      <div
        v-click-outside="closeSelect"
        class="exam-search__select"
      >
        <div class="exam-search__input-wrapper">
          <input
            v-model="searchText"
            type="text"
            class="exam-search__input"
            placeholder="Pesquise por nome, código e sinônimos do exame"
            @click="handleInputClick"
            @input="textSearch"
            @keyup.enter="handleSearch"
          />
          <spinner
            v-if="loading && searchText.length > 1"
            class="small"
          />
        </div>
        <div
          v-if="showList"
          class="exam-search__result"
        >
          <div
            v-if="items.length === 0"
            class="exam-search__no-results"
          >
            Nenhum exame foi encontrado
          </div>
          <div
            v-for="(exam, index) in items"
            :key="`exam-search-${index}-${exam.id || exam.code || index}`"
            class="exam-search__option"
            @click="handleSelect(exam)"
          >
            <span v-html="exam.label" />
          </div>
        </div>

        <div
          v-if="errorSearch && !isSelectOpen"
          class="exam-search__result"
        >
          <div
            class="exam-search__no-results"
            style="color: red"
          >
            Pesquise por pelo menos 2 caracteres
          </div>
        </div>
      </div>
      <button
        v-if="btnSearch"
        class="exam-search__btn"
        @click="handleSearch"
      >
        <svg-loader src="../../../../static/images/icon-search.svg" />
      </button>
    </div>
    <div />
  </div>
</template>

<script>
import examGuideService from '@/api/examGuide'
import { clickOutside } from '@/utils/directives'
import Spinner from '@/components/common/Spinner'

export default {
  name: 'ExamSearch',
  components: { Spinner },
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his children
          if (!(el === event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    },
    clickOutside,
  },
  props: {
    results: {
      type: Boolean,
      default: false,
    },
    inputText: {
      type: String,
      default: '',
    },
    title: {
      type: Boolean,
      default: true,
    },
    btnSearch: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    searchText: '',
    timer: undefined,
    isSelectOpen: false,
    examSelected: false,
    examList: [],
    loading: false,
    errorSearch: false,
  }),
  computed: {
    showList() {
      if (
        this.isSelectOpen &&
        !this.examSelected &&
        this.searchText.length > 1 &&
        !this.loading
      )
        return true
      return false
    },
    items() {
      let items = this.examList
      let text = this.searchText
      text = text.toUpperCase()
      items.map(item => {
        item.label = item.mnemonic + ' - ' + item.name
        item.label = item.label.toUpperCase()
        item.label = this.stringHighlight(item.label, text)
        return item
      })
      return items
    },
  },
  watch: {
    searchText(newVal) {
      if (newVal.length > 1 && this.examList.length > 0) {
        this.isSelectOpen = true
      } else {
        this.isSelectOpen = false
      }
    },
    inputText(newVal) {
      this.searchText = newVal
    },
  },
  mounted() {
    this.examSelected = true
  },
  methods: {
    processSearchTermToConsiderAccent(baseSearch) {
      let processed = baseSearch.toLowerCase()
      processed = processed.replace(/[aáâã]/g, '[aáâãAÁÂÃ]')
      processed = processed.replace(/[eéêẽ]/g, '[eéêẽEÉÊẼ]')
      processed = processed.replace(/[iíîĩ]/g, '[iíîĩIÍÎĨ]')
      processed = processed.replace(/[oóôõ]/g, '[oóôõOÓÔÕ]')
      processed = processed.replace(/[uúûũ]/g, '[uúûũUÚÛŨ]')
      processed = processed.replace(/[cç]/g, '[cçCÇ]')
      return processed
    },
    stringHighlight(item, search) {
      if (search !== '' && search.length > 1) {
        var regex = new RegExp(
          '(' + this.processSearchTermToConsiderAccent(search) + ')',
          'gi'
        )
        return item.replace(regex, '<b>$1</b>')
      } else {
        return item
      }
    },
    searchExam(searchText, submit) {
      if (submit) {
        this.$emit('loading', true)
      }
      this.loading = true
      if (searchText.length > 0) {
        this.$emit('searchAll', false)
        examGuideService
          .examSearch(searchText)
          .then(res => {
            this.examList = res.data
            this.loading = false
            if (submit) {
              this.$emit('loading', false)
              this.$emit('updateList', this.examList)
            }
          })
          .catch(() => {
            this.examList = []
            this.loading = false
            if (submit) {
              this.$emit('loading', false)
              this.$emit('updateList', this.examList)
            }
          })
      } else {
        const page = 0 // at backend page starts on zero
        examGuideService
          .examSearchAll(page)
          .then(res => {
            this.examList = res.data
            this.loading = false
            this.$emit('loading', false)
            this.$emit('updateList', this.examList)
            this.$emit('searchAll', true)
          })
          .catch(() => {
            this.examList = []
            this.loading = false
            this.$emit('loading', false)
            this.$emit('updateList', this.examList)
          })
      }
    },
    textSearch() {
      this.errorSearch = false
      this.examList = []
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        if (this.searchText.length > 1) {
          this.searchExam(this.searchText)
          this.isSelectOpen = true
        }
      }, 800)
    },
    handleSearch() {
      if (this.searchText && this.searchText.length > 1) {
        this.errorSearch = false
        if (this.$route.name === 'Resultado da pesquisa') {
          this.searchExam(this.searchText, true)
          this.isSelectOpen = false
        } else {
          this.$router.push({
            path: '/exames/resultado-da-pesquisa',
            query: { searchText: this.searchText },
          })
        }
      } else {
        this.errorSearch = true
      }
    },
    handleInputClick() {
      this.isSelectOpen = true
      this.textSearch()
      this.examSelected = false
    },
    handleSelect(exam) {
      this.searchText = exam.mnemonic + ' - ' + exam.name
      this.examSelected = true
      this.$router.push({
        path: '/exames/detalhes',
        query: { mnemonic: exam.mnemonic },
      })
    },
    closeSelect() {
      this.isSelectOpen = false
    },
  },
}
</script>

<style lang="scss">
.exam-search-results {
  .loader.small {
    position: absolute;
    top: 10px;
    right: 15px;
  }
  h1 {
    text-align: left;
    font-size: 24px;
    margin-bottom: 15px !important;
  }

  .exam-search__wrapper {
    margin: 0;
    max-width: 430px;
  }

  .exam-search__input {
    position: relative;
    border-color: #d8d8d8;
    background-image: url('/static/images/site/icon-search-light.svg');
  }
}
.exam-search {
  z-index: 3 !important;
  &__title {
    color: #303030 !important;
    text-align: center;
    font-size: 32px;
    margin: 0 0 20px !important;
    line-height: 1;
  }
  &__input-wrapper {
    position: relative;
  }
  .loader.small {
    position: absolute;
    top: 10px;
    right: 15px;
  }
  &__input {
    border: 1px solid #7f1a54;
    height: 38px;
    border-radius: 4px;
    padding: 5px 15px;
  }
  &__no-results {
    padding: 6px 12px;
    color: #6a6a6a;
  }
  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 600px;
    margin: 0 auto 60px;
    @media (max-width: 769px) {
      padding: 0 7%;
    }
  }
  &__select {
    width: calc(100% - 48px);
    position: relative;
  }
  &__result {
    position: absolute;
    background-color: #fff;
    width: 100%;
    padding: 7px 0;
    border-radius: 0 0 6px 6px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.14);
  }
  &__option {
    display: flex;
    cursor: pointer;
    padding: 7px 16px;

    b {
      color: #7f1a54;
    }

    &:hover {
      background-color: #f4f4f4;
    }

    span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 100%;
      letter-spacing: 0;
    }
  }
  &__input {
    border: 1px solid #7f1a54;
    height: 38px;
    border-radius: 4px;
    padding: 5px 15px 5px 35px;
    background-image: url('/static/images/icon-search-purple.svg');
    background-repeat: no-repeat;
    background-position: 10px center;
    width: 100%;
    outline: none;

    &:focus {
      border-color: #ee5c53;
      background-image: url('/static/images/icon-search-orange.svg');
    }
  }
  &__btn {
    background-color: #7f1a54;
    border-radius: 100%;
    display: block;
    width: 38px;
    height: 38px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);

    svg {
      fill: #fff;
    }
  }
}
</style>
